import {Component, OnInit} from '@angular/core';
import {OwnerCrudService} from '../services/owner-crud.service';
import {LeadService} from '../../leads/services/lead.service';
import {Router, ActivatedRoute} from '@angular/router';
import {OwnersForm} from '../models/data-model';
import {GlobalDataService} from "../../housekeeping/services/global-data.service";

@Component({
  selector: 'app-ownerchange',
  templateUrl: '../views/ownerchange.component.html',
  styleUrls: ['../css/ownerchange.component.css']
})
export class OwnerchangeComponent implements OnInit {

  public vehicleData: any;
  public ownerId = "";
  public ownername = "";
  public errorMessage = "";
  public make: string;
  public model: string;
  public countryCode: string = "";
  public salesTypename: string = "";
  public cycleCodename: string = "";
  public vin: any = null;
  public purchaseDate: Date = new Date();
  public warrantyDate: Date;
  public year: number = null;
  //public userId = localStorage.getItem('userId');
  public userId = sessionStorage.getItem('userId');
  public countryList: any;
  public salesList: any;
  public ownershipcycle: any;
  public vechileid = "";
  public prevFirstName:string = "";
  public prevLastName:string = "";
  public vechileForm = {
    id: null,
    sugarVKey: null,
    individualId: null,
    vin: null,
    purchaseDate: new Date(),
    warrantyDate: new Date(),
    cycle: {
      id: null,
      code: "",
      description: "",
      active: null
    },
    salesType: {
      id: null,
      code: "",
      description: "",
      active: null
    },
    vehicleType: {
      id: null,
      make: "",
      model: ""
    },
    year: null,
    dateEntered: Date,
    createdBy: null,
    dateModified: null,
    modifiedBy: null,
    deleted: null,
    dateSynced: null
  };
  public ownersForm = new OwnersForm(
    null, null, null, null, null, null, null, null, null, null, null, null, null, {},
    {
      id: '',
      superDealerCode: '',
      name: '',
      globalCode: '',
      localCode: '',
      regionCode: '',
      countryCode: ''
    }, null, {}, null,
    {
      id: "",
      address1: "",
      address2: "",
      address3: "",
      address4: "",
      city: "",
      postalCode: null,
      stateId: {
        id: null,
        stateCode: null,
        name: ""
      },
      countryId: {
        id: null,
        code: null,
        name: ""
      }
    }, null, [
      {
        id: null,
        sugarVKey: null,
        individualId: null,
        vin: null,
        purchaseDate: new Date(),
        warrantyDate: Date,
        cycle: {
          id: null,
          code: "",
          description: "",
          active: null
        },
        salesType: {
          id: null,
          code: "",
          description: "",
          active: null
        },
        vehicleType: {
          id: null,
          make: "",
          model: ""
        },
        year: null,
        dateEntered: Date,
        createdBy: null,
        dateModified: null,
        modifiedBy: null,
        deleted: null,
        dateSynced: null
      }
    ]
  );
  public dealerList: any;
  public dealerName = "";
  submitted: boolean = false
  public ownerVehicleId: string = ""

  constructor(public _ownerCrudService: OwnerCrudService, public _leadService: LeadService, public activeroute: ActivatedRoute, public _router: Router, public _dataService: GlobalDataService) {
  }

  ngOnInit() {
    this.getCountryList();
    this.getDealerList();
    this.getsalesList();
    this.getOwnershipcycle();
    this.activeroute.params.subscribe(
      params => {
        if (Object.keys(params).length != 0) {
          this.ownerId = params.id;
          this.vin = params.vin
          this.ownerVehicleId = params.vehicleId
        }
      });
    this.getOwnerDetails();

  }

  /**
   * @author Pradeep
   * @description get all dealer list
   */
  getDealerList() {
    this._leadService.getDealerList(this.userId, (result) => {
      //  console.log("*****************"+JSON.stringify(result))
      this.dealerList = result.sort(this.dynamicSort("globalCode"));
    });

  }

  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }

  /**
   * @author Pradeep
   * @description get country list
   */
  getCountryList() {
    this._leadService.getCountryList(this.userId, (result) => {
      this.countryList = result;
    });
  }

  /**
   * @author Pradeep
   * @description get dealar name based on dealer id
   */
  getDealerName(e) {
    if (this.dealerList.length > 1) {
      let dealername = "";
      let dealercode = "";
      this.dealerList.forEach(function (value) {
        if (value.id == e.target.value) {
          dealername = value.name;
          dealercode = value.globalCode;

        }
      });
      this.ownersForm.dealerId.name = dealername;
      this.ownersForm.dealerId.globalCode = dealercode;
      this.dealerName = dealername
    }
  }

  getsalesList() {
    this._ownerCrudService.getsalesList(this.userId, (result) => {
      this.salesList = result;
    });
  }

  getOwnershipcycle() {
    this._ownerCrudService.getOwnershipcycle(this.userId, (result) => {

      this.ownershipcycle = result;
    });
  }

  getOwnerDetails() {
    const thisObj = this;
    this._ownerCrudService.viewOwnerDetails(this.vin, this.ownerId, this.userId, this.ownerVehicleId, (result) => {
      this.prevFirstName =thisObj.ownersForm.firstName;
      this.prevLastName = thisObj.ownersForm.lastName;
      thisObj.ownersForm = result;
      thisObj.vehicleData = result.vehicles;
      thisObj.ownername = thisObj.ownersForm.firstName + " " + thisObj.ownersForm.lastName;

      if (result.dealerId == null) {
        thisObj.ownersForm.dealerId = {
          id: '',
          superDealerCode: '',
          name: '',
          globalCode: '',
          localCode: '',
          regionCode: '',
          countryCode: ''
        };
      } else {
        thisObj.ownersForm.dealerId = result.dealerId;
        thisObj.dealerName = result.dealerId.name
      }
      thisObj.purchaseDate = new Date();
      //thisObj.dealerName= (result.dealerId!=null)?result.dealerId.name:"";
      if (thisObj.vehicleData.length != 0) {
        for (let index = 0; index < this.vehicleData.length; index++) {
          if (this.vehicleData[index].vin == this.vin) {
            thisObj.warrantyDate = result.vehicles[index].warrantyDate;
            thisObj.vechileForm.cycle.id = '';
            thisObj.vechileForm.cycle.description = '';
            thisObj.vechileForm.salesType.id = '';
            if (result.vehicles[index].vehicleType != null) {
              thisObj.vechileid = result.vehicles[index].vehicleType.id;
              thisObj.make = result.vehicles[index].vehicleType.make;
              thisObj.model = result.vehicles[index].vehicleType.model;
            } else {
              thisObj.make = "";
              thisObj.model = "";
            }
            thisObj.vin = result.vehicles[index].vin;
            thisObj.year = result.vehicles[index].year;
          }

        }

        /*  if(result.vehicles[0].cycle != null){
           thisObj.vechileForm.cycle.id=result.vehicles[0].cycle.id;
           thisObj.vechileForm.cycle.description=result.vehicles[0].cycle.description;
          }else{ */

        /* } */
//                if(result.vehicles[0].salesType != null){
//                 thisObj.vechileForm.salesType.id=result.vehicles[0].salesType.id;
//                }else{

        //}

      } else {
        thisObj.make = "";
        thisObj.model = "";
        thisObj.salesTypename = "";
        thisObj.cycleCodename = "";
        thisObj.vin = null;
        thisObj.purchaseDate = new Date();

        thisObj.year = null;
      }
      thisObj.ownersForm.companyName = "";
      thisObj.ownersForm.firstName = "";
      thisObj.ownersForm.lastName = "";
      thisObj.ownersForm.phone = null;
      thisObj.ownersForm.phoneTimeToCall = "";
      thisObj.ownersForm.mobile = null;
      thisObj.ownersForm.mobileTimeToCall = "";
      thisObj.ownersForm.email = "";
      thisObj.ownersForm.optedIn = "false";
      thisObj.ownersForm.addressId.countryId = {id: null, code: null, name: null};

      if (result.statusCodes == "MISSING_OWNER_VEHICLE") {
        this.errorMessage = "Vehicle details are not available. So not able change ownership."
      }

    });
  }

  saveChangeOwner() {
    this.ownersForm.vehicles = this.vehicleData;
    //this.ownersForm.id = null;
    this.vechileForm.vin = this.vin;
    this.vechileForm.year = this.year;
    this.vechileForm.purchaseDate = this.purchaseDate;
    this.vechileForm.warrantyDate = this.warrantyDate;
    this.vechileForm.vehicleType.id = this.vechileid;
    this.ownersForm.userId = Number(this.userId);
    if (this.ownersForm.vehicles.length > 0) {
      this.ownersForm.vehicles[0].purchaseDate = this.purchaseDate;
      this.ownersForm.vehicles[0].warrantyDate = this.warrantyDate;
      this.ownersForm.vehicles[0].salesType = {
        id: this.vechileForm.salesType.id,
        code: "",
        description: null,
        active: null
      };
      if (this.ownersForm.vehicles[0].cycle == null) {
        this.ownersForm.vehicles[0].cycle = {id: null, code: "", description: "", active: null}
      }
      this.ownersForm.vehicles[0].cycle.id = this.vechileForm.cycle.id;

    }
    // console.log(this.ownersForm.vehicles[0].purchaseDate + "************************" + JSON.stringify(this.ownersForm))
    this._ownerCrudService.saveChangeOwner(this.ownersForm, (result) => {
      //  console.log("^^^^^^^^^^^^^^^^^^^^^^^^" + JSON.stringify(result))
      if (result.statusCodes == "OWNER_SAVED_SUCCESSFULLY") {
        this._dataService.trackUserClick(this.userId,"OwnerChange_FN:"+this.prevFirstName+"->"+this.ownersForm.firstName);
        this._dataService.trackUserClick(this.userId,"OwnerChange_LN:"+this.prevLastName+"->"+this.ownersForm.lastName);
        this._router.navigate(["/owners/detail/" + result.id + "/" + this.vin + "/" + this.ownerVehicleId]);
      } else if (result.statusCodes == "MISSING_OWNER_VEHICLE") {
        this.ownersForm.vehicles = this.vehicleData[0];
        this.errorMessage = "Vehicle details are not available. So not able change ownership."
      } else {
        this.ownersForm.vehicles = this.vehicleData[0];
        this.errorMessage = "Failed to update owner."
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/owners/components/ownerchange.component.ts